import React from 'react'
import Header from './Header';
import Footer from './Footer';
import Specialoffer from './Specialoffer';
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from 'react';



const imageFiles = [
   
   "import.png",
   "renovation.png",
   "software.png",
   "Supplier.png"
 ]; 

function Home() {

   useEffect(() => {
      AOS.init({ duration: 1000 });
    }, []);
  return (
     <>
     <Header />
        <div className="layout_padding">
            <div class="container">
               <div class="row margindiv">
                  <div class="col-md-7">
                     <h1 class="banner_taital">All Your Needs
                     in  <span style={{ color: "rgb(32 129 108)" }}>One Platform</span></h1>
                     <p class="banner_text">We are dedicated to delivering a comprehensive range of services
                     tailored to meet all your needs in one platform.</p>
                     <div class="started_text2"><a href="/Quote">Get A Quote</a></div>
                     <div class="started_text"><a href="/Contact">Contact Us</a></div>
                    
                  </div>
                  <div class="col-md-5">
                     <div id="banner_slider" class="carousel slide" data-ride="carousel">
                        <div class="carousel-inner">
                           {imageFiles.map((image, index) => (
                                 <div
                                 key={index}
                                 className={`carousel-item ${index === 0 ? "active" : ""}`}
                                 >
                                 <div className="banner_img">
                                    <img src={`Assets/images/Service/${image}`} alt={`Slide ${index + 1}`} className="d-block w-100" />
                                 </div>
                                 </div>
                              ))}
                         
                        </div>
                        <a class="carousel-control-prev" href="#banner_slider" role="button" data-slide="prev">
                        <i class="fa fa-angle-left"></i>
                        </a>
                        <a class="carousel-control-next" href="#banner_slider" role="button" data-slide="next">
                        <i class="fa fa-angle-right"></i>
                        </a>
                     </div>
                  </div>
               </div>

               <marquee behavior="scroll" direction="left"><h1>Welcome to DHK Service Ltd.All our service for your satisfaction .</h1></marquee>

             {/* <Specialoffer /> */}
            </div>
         </div>


         <div  data-aos="fade-up" className="services_section mt-4">
            <div className="container">
              

               <div className="row">
               <h1 class="blog_taital">Our Services</h1>

                   

                    <div class="col-lg-3 col-md-6 margin-30px-bottom xs-margin-20px-bottom">
                        <div class="services-block-three">
                            <Link to="/Services/3">
                                <div class="padding-15px-bottom">
                                <img src="Assets/images/Service/renovation.png" alt="jhjh" className="card-img-top"style={{ height: "220px", objectFit: "cover" }} />
                                </div>
                                <h2>Renovation &
                                Restoration</h2>
                                <p class="xs-font-size13 xs-line-height-22">Transform your space with our
                                 expert renovation and restoration
                                 services. Whether you're updating
                                 your home or restoring a historic
                                 building, our skilled craftsmen are
                                 committed.</p>
                            </Link>
                        </div>
                    </div>


                    <div class="col-lg-3 col-md-6 margin-30px-bottom xs-margin-20px-bottom">
                        <div class="services-block-three">
                            <Link to="/Services/2">
                                <div class="padding-15px-bottom">
                                <div>
                                <img src="Assets/images/Service/Supplier.png" alt="jhjh" className="card-img-top"style={{ height: "220px", objectFit: "cover" }} />
                               
                                </div>
                                </div>
                                <h3>Workwear Supplies</h3>
                                <p class="xs-font-size13 xs-line-height-22">We understand the importance of
                                    quality workwear in enhancing
                                    safety and professionalism. DHK
                                    Service Oy provides a wide range of
                                    workwear supplies that combine
                                    durability with comfort.</p>
                            </Link>
                        </div>
                    </div>


                    <div class="col-lg-3 col-md-6 margin-30px-bottom xs-margin-20px-bottom">
                        <div class="services-block-three">
                            <Link to="/Services/4">
                                <div class="padding-15px-bottom">
                                <div>
                                <img src="Assets/images/Service/import.png" alt="jhjh" className="card-img-top"style={{ height: "220px", objectFit: "cover" }} />
                               
                                </div>
                                </div>
                                <h3>Import & Export</h3>
                                <p class="xs-font-size13 xs-line-height-22">
                                 Our import and export services
                                 enable businesses to expand their
                                 reach and access essential materials
                                 and products from around the
                                 globe. We facilitate seamless transactions,
                                 allowing you to focus on
                                 your core operations.
                                </p>
                            </Link>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-6 margin-30px-bottom xs-margin-20px-bottom">
                        <div class="services-block-three">
                            <Link to="/Services/5">
                                <div class="padding-15px-bottom">
                                <div>
                                <img src="Assets/images/Service/software.png" alt="jhjh" className="card-img-top"style={{ height: "220px", objectFit: "cover" }} />
                               
                                </div>
                                </div>
                                <h3>IT Service & Solution</h3>
                                <p class="xs-font-size13 xs-line-height-22">In today’s digital age, having a strong online presence
                                 is crucial. Our talented developers create customized
                                 websites and applications designed to elevate
                                 your brand, improve customer engagement,
                                 and drive growth. </p>
                            </Link>
                        </div>
                    </div>
                  </div>

            </div>
         </div>

         
         

      <div className="why layout_padding" >

           <div className="container">
           <h1 class="blog_taital">Why choose us ?</h1>

                  <div className="row text-center" style={{ paddingTop: "30px" }} >
                     <div className="col-md-3 mb-4" data-aos="fade-left" data-aos-delay="100">
                        <div className="p-4 border rounded h-100 shadow-sm">
                        <div className="mb-3">
                           <i className="fas fa-star fa-2x text-primary"></i>
                        </div>
                        <h2 className="font-weight-bold">Top Quality</h2>
                        <p className="text-muted">
                           We deliver unmatched service and top-quality solutions to all our clients.
                        </p>
                        </div>
                     </div>

                     <div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="200">
                        <div className="p-4 border rounded h-100 shadow-sm">
                        <div className="mb-3">
                           <i className="fas fa-users fa-2x text-success"></i>
                        </div>
                        <h2 className="font-weight-bold">Experienced Team</h2>
                        <p className="text-muted">
                           Our team consists of experts with years of industry experience.
                        </p>
                        </div>
                     </div>

                     <div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="300">
                        <div className="p-4 border rounded h-100 shadow-sm">
                        <div className="mb-3">
                           <i className="fas fa-headset fa-2x text-warning"></i>
                        </div>
                        <h2 className="font-weight-bold">Quick Support</h2>
                        <p className="text-muted">
                           We’re here for you around the clock, ready to help whenever you need us.
                        </p>
                        </div>
                     </div>

                     <div className="col-md-3 mb-4" data-aos="fade-right" data-aos-delay="400">
                        <div className="p-4 border rounded h-100 shadow-sm">
                        <div className="mb-3">
                           <i className="fas fa-euro fa-2x text-success"></i>
                        </div>
                        <h2 className="font-weight-bold">Best Price</h2>
                        <p className="text-muted">
                           We’re here providing best pricing with good quality according to your needs.
                        </p>
                        </div>
                     </div>
                  </div>
            </div>
               
         </div>


      <div class="customer_section "  >
         <div class="container">
         <h1 class="blog_taital">What Is says Our customers</h1>
         </div>
         <div id="my_slider" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner">
               <div class="carousel-item active">
                  <div class="customer_section_2">
                     <div class="container">
                        <div class="row">
                           <div class="col-md-12">
                              <div class="box_main">
                                 <div class="customer_main">
                                    <p class="enim_text">Thanks for your service. Great initiatives. I would prefer to take your service again.</p>
                                    <div class="customer_left">
                                       <div class="customer_img"><img src="Assets/images/profile.jpg"/></div>
                                    </div>
                                    <div class="customer_right">
                                       <h3 class="customer_name">Samsuzzoha Sifat</h3>
                                     
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="carousel-item">
                  <div class="customer_section_2">
                     <div class="container">
                        <div class="row">
                           <div class="col-md-12">
                              <div class="box_main">
                                 <div class="customer_main">
                                    <p class="enim_text">I relied on DHK Services Oy for both van rental and construction cleaning during my office relocation. </p>
                                    <div class="customer_left">
                                       <div class="customer_img"><img src="Assets/images/profile.jpg"/></div>
                                    </div>
                                    <div class="customer_right">
                                       <h3 class="customer_name">Aada Matilda</h3>
                                      
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="carousel-item">
                  <div class="customer_section_2">
                     <div class="container">
                        <div class="row">
                           <div class="col-md-12">
                              <div class="box_main">
                                 <div class="customer_main">
                                    <p class="enim_text">Mahtava kuski+paku -palvelu! Ihan 10/10. Ystävällinen, avulias, miellyttävä kuljettaja.</p>
                                    <div class="customer_left">
                                       <div class="customer_img"><img src="Assets/images/profile.jpg"/></div>
                                    </div>
                                    <div class="customer_right">
                                       <h3 class="customer_name">Toni</h3>
                                      
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <a class="carousel-control-prev" href="#my_slider" role="button" data-slide="prev">
            <i class="fa fa-angle-left"></i>
            </a>
            <a class="carousel-control-next" href="#my_slider" role="button" data-slide="next">
            <i class="fa fa-angle-right"></i>
            </a>
         </div>
      </div>

      

         <div class="shop_section layout_padding" data-aos="fade-up">
            <div class="container">
               <div class="row">
                  <div class="col-md-12">
                     <h1 class="shop_taital">Do you need any help ? </h1>
                     <p class="shop_text">Call us at <span style={{ color: "#2b2b2b", fontWeight:"bold" }}> +358 40 053 6756‬
</span> or you can click on below button.</p>
                     <div class="btn_main2">
                        <div class="chat_bt "><a href="Assets/DHK_company_profile_Finnish.pdf" target='_blank'>Company Profile</a></div>
                        <div class="call_bt "><a href="/Contact">Contact Us</a></div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         

         <Footer />

     

     </>   


   
  )
}

export default Home